import SummaryAddonTable from "models/backoffice/modelComponents/SummaryAddonTable";

import Slide from "models/backoffice/slideDesign/Slide";
import SlideTitle from "models/backoffice/slideDesign/SlideTitle";
import { forwardRef } from "react";

const FundSummaryAddonSlide = forwardRef(
  ({ vizInfo, scaleActive, configurationLinks }, ref) => {
    return (
      <Slide slideWidth={1000} scaleActive={scaleActive} loading={!vizInfo}>
        <SlideTitle size={2}></SlideTitle>
        <SummaryAddonTable ref={ref} vizInfo={vizInfo} />
      </Slide>
    );
  },
);

export default FundSummaryAddonSlide;
